import * as React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import Icon from "../Icon";
import * as colors from "../../settings/colors";

const activeClassName = "nav-item-active";

const SidebarLink = ({ icon, text, ...otherProps }) => (
  <NavLink {...otherProps} activeClassName={activeClassName}>
    <Icon icon={icon} size={24} /> {text}
  </NavLink>
);

const StyledSidebarLink = styled(SidebarLink)`
  display: flex;
  align-items: center;
  color: ${colors.SIDEBAR_TEXT};
  font-size: 14px;
  padding: 12px 16px;
  text-decoration: none;

  & > svg {
    padding-right: 8px;
    fill: ${colors.SIDEBAR_TEXT};
  }

  &:hover {
    color: ${colors.SIDEBAR_HOVER_TEXT};

    & > svg {
      fill: ${colors.SIDEBAR_HOVER_TEXT};
    }
  }

  &:active,
  &.${activeClassName} {
    font-weight: 600;
    color: ${colors.SIDEBAR_ACTIVE_TEXT};

    & > svg {
      fill: ${colors.SIDEBAR_ACTIVE_TEXT};
    }
  }
`;

export default StyledSidebarLink;



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarLink.js